/* eslint-disable */
// tw.js
export const locale = {
  GENERAL: {
    NAV_OPTIONS: ['首頁', '藏書閣主', '網站說明', '百人小傳', '觀古珍藏', '視覺展示', '資料庫檢索', '主題研究'],
    WELCOME_WORD: '歡迎來到 Vue.js 應用程式', // for main content
  },
}
